import React from "react";
import Logo from "../../../containers/assets/LandingPageLogo2.png";

function TeamReportsWelcomeLayout({
  title = "",
  left_content = "",
  right_content = ""
}) {
  return (
    <div className="team-reports-layout team-reports-layout-welcome">
      <div className="team-reports-logo">
        <img src={Logo} alt="logo" />
      </div>
      <div className="title">{title}</div>
      <div className="welcome-inner-content clearfix">
        <div className="left">{left_content}</div>
        <div className="right">{right_content}</div>
      </div>
    </div>
  );
}

export default TeamReportsWelcomeLayout;



// WEBPACK FOOTER //
// ./src/components/team-reports/layouts/welcome.js